import { render, staticRenderFns } from "./ModalCourseDetail.vue?vue&type=template&id=60f3df0c&scoped=true"
import script from "./ModalCourseDetail.vue?vue&type=script&lang=js"
export * from "./ModalCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./ModalCourseDetail.vue?vue&type=style&index=0&id=60f3df0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f3df0c",
  null
  
)

export default component.exports